export default "__VITE_ASSET__DqS26E3Y__"